import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'ep-space',
  template: '',
  styleUrls: ['./space.component.scss'],
  host: {
    '[style.height.px]': 'heightInPixels',
  },
  inputs: ['hasSafeArea','heightInPixels'],
})
export class SpaceComponent {

  @HostBinding('style.margin-top') marginTop?: string;
  @Input() set hasSafeArea(hasSafeArea: boolean) {
    if (hasSafeArea) {
       this.marginTop = 'env(safe-area-inset-top)'
    }
  }

  @Input() heightInPixels: number = 0;

}
